import React, { useState, useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { notification } from 'antd';
import { XMLParser } from 'fast-xml-parser';
import commonLib from '../../control/commonLib';
import './DocumentEditor.css';

const PAGE_HEIGHT = 1123;

const FULL_LOCK_CONFIG = {
  '7_1': [
    { matchText: 'How Co-Agents Shall Act.' },
    { matchText: 'Should there be any discrepancy between the individuals named in this document' },
  ],
  '6_1': [
    { matchText: 'How Co-Agents Shall Act.' },
    { matchText: 'Should there be any conflict between the individuals named in this document' },
  ],
  '9_1': [
    { matchText: 'How Co-Agents Shall Act.' },
    { matchText: 'Should there be any discrepancy between the individuals named in this document' },
  ],
  '14_1': [
    { matchText: 'How Co-Agents Shall Act.' },
  ],
};

const PARTIAL_LOCK_CONFIG = {
  '5_1': [
    {
      startText: 'I waive attorney-client privilege',
      endText: 'or disappearance.',
    },
    {
      startText: 'At any time in the future when you are contacted',
      endText: 'from my treating physician.',
    },
    {
      startText: 'In the event that you believe that my designated agent',
      endText: 'fiduciary responsibilities.',
    },
    {
      startText: 'Your reasonable fees for acting pursuant',
      endText: 'shall be paid from my estate.',
    },
  ],
  '6_1': [
    {
      startText: 'Directive for Treatment. I want my life to be prolonged',
      endText: 'in a Permanent Unconscious Condition:',
    },
    {
      startText: 'Directive to Withhold or Withdraw Treatment',
      endText: 'to be kept comfortable and pain-free to the maximum extent possible.',
      multiPara: true,
    },
    {
      startText: 'Terri Schiavo Provision',
      endText: 'for the provision of medical care that will create a financial hardship for me, my family, or other loved ones.',
      multiPara: true,
    },
  ],
  '7_1': [
    {
      startText: 'Effectiveness and Duration. This Durable Power of Attorney shall become effective immediately',
      endText: 'dead or alive.',
    },
    {
      startText: 'Effectiveness and Duration. This Durable Power of Attorney shall become effective upon my disability or incapacity',
      endText: 'dead or alive.',
    },
    {
      startText: 'Make transfers of my property, including but not limited to transfers to my spouse and gifts to my children',
      endText: 'Transfers should be consistent with my estate plan.',
    },
    {
      startText: 'Make transfers of my property, including but not limited to transfers to my spouse, for the purpose',
      endText: 'Transfers should be consistent with my estate plan.',
    },
    {
      startText: 'Make transfers of my property, including but not limited to gifts to my children',
      endText: 'Transfers should be consistent with my estate plan.',
    },
    {
      startText: 'Make transfers of my property for the purpose of qualifying me for governmental medical assistance',
      endText: 'Transfers should be consistent with my estate plan.',
    },
    {
      startText: 'Create, amend, or revoke any community property agreement',
      endText: 'those interested in my estate.',
    },
    {
      startText: 'Create, amend, or revoke any of my life insurance, retirement',
      endText: 'those interested in my estate.',
    },
    {
      startText: 'Duty to Keep Affairs Transparent.',
      endText: '',
    },
    {
      startText: 'Appointment of {Guardian1} of Minor Children',
      endText: 'to so act as successor {Guardian3}.',
    },
    {
      startText: 'Burden on Named Agents and Loved Ones.',
      endText: 'hired professional.',
    },
    {
      startText: 'Elder Law Attorney:',
      endText: 'go to www.waela.org.',
      multiPara: true,
    },
  ],
  '14_1': [
    {
      startText: 'Effectiveness and Duration. This Durable Power of Attorney for Health Care shall become effective immediately',
      endText: 'dead or alive.',
    },
    {
      startText: "Required First Assessment and Agent's Discretion to Hire a Geriatric Care Manager.",
      endText: 'select a care management company from the listed providers.',
      multiPara: true,
    },
    {
      startText: "Agent's Duty to Hire a Geriatric Care Manager.",
      endText: 'the GCM shall work with my agent and family towards this goal.',
      multiPara: true,
    },
    {
      startText: "Agent's Discretion to Hire a Geriatric Care Manager.",
      endText: 'select a care management company from the listed providers.',
      multiPara: true,
    },
    {
      startText: "Locating and Arranging Caregivers.",
      endText: 'does not serve my best interests.',
      multiPara: true,
    },
  ],
  '16_1': [
    {
      startText: 'I direct that my remains be (CHOOSE ONE)',
      endText: 'other (describe):',
      multiPara: true,
    },
    {
      startText: 'At this time, I have not',
      endText: 'as closely as possible.',
      multiPara: true,
    },
    {
      startText: 'I have made arrangements for the disposition of my remains with the following',
      endText: '',
      multiPara: true,
    },
    {
      startText: 'At this time, I ***',
      endText: 'If arrangements have been made, describe',
      multiPara: true,
    },
    {
      startText: 'Interment of Ashes.{B1}',
      endText: '',
      multiPara: true,
    },
    {
      startText: 'Interment of Ashes.{B2}',
      endText: 'at the discretion of my representative.',
    },
    {
      startText: 'Dispersal of Ashes. {A2}',
      endText: 'at the discretion of my representative.',
    },
    {
      startText: 'Dispersal of Ashes. {A3}',
      endText: 'Dispersed as follows:',
      multiPara: true,
    },
    {
      startText: 'Burial Policy. I have a burial policy with the following company:',
      endText: '',
      multiPara: true,
    },
    {
      startText: 'Telephone Number to call:',
      endText: ':',
      multiPara: true,
    },
    {
      startText: 'Anatomical Gift.{I1}',
      endText: 'persons designated under RCW § 68.50.160.',
    },
    {
      startText: 'Anatomical Gift.{I2}',
      endText: 'prepare a UW Willed Body Program form.',
      multiPara: true,
    },
    {
      startText: 'Anatomical Gifts.',
      endText: 'donated to others.',
    },
    {
      startText: 'Anatomical Gift.{I4}',
      endText: 'I do not wish any of my organs or body parts to be donated to others.',
      multiPara: true,
    },
    {
      startText: 'These arrangements{T1}',
      endText: 'may be supplemented by my representative.',
      multiPara: true,
    },
    {
      startText: 'at the following cemetery:',
      endText: 'Plot Number:',
      multiPara: true,
    },
    {
      startText: 'Cremation Policy. I have a cremation policy or membership with the following company:',
      endText: '',
      multiPara: true,
    },
  ],
  '9_1': [
    {
      startText: 'Preferences and Instructions About Who is Permitted to Visit.',
      endText: 'the following people are not permitted to visit me there:',
    },
  ],
};

const TEXT_COLORS = [
  '#000000', '#2b2b2b', '#555555', '#7f7f7f', '#a6a6a6', '#c2186d',
  '#c0392b', '#e74c3c', '#d4730a', '#e67e22', '#a87900', '#f1c40f',
  '#1e7a34', '#27ae60', '#127a6e', '#16a085', '#1f4e9c', '#2980b9',
  '#1b2f5e', '#1a73a8', '#6c3483', '#8e44ad', '#9c1f6b',
]?.map(v => ({ label: v, value: v }));

const HIGHLIGHT_COLORS = [
  'transparent',
  '#ffff00', '#ffe066', '#ffd28a', '#ffb877', '#ffcdb0', '#ff9e9e',
  '#f7b6c2', '#f3a6e0', '#dcc4f0', '#d4d4f7', '#b3b3f7', '#a9d4f5',
  '#8ec9f0', '#bfeaf5', '#aef0e5', '#8de0d3', '#a6f1a6', '#7fdb7f',
  '#d6f5a6', '#e8d8b8', '#d9d9d9', '#bfbfbf', '#ffffff',
]?.map(v => ({ label: v === 'transparent' ? 'None' : v, value: v }));

function ColorPickerDropdown({ label, icon, colors, currentColor, onSelect, swatchExtraClass }) {
  const [isOpen, setIsOpen] = useState(false);
  const [panelStyle, setPanelStyle] = useState({});
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isOpen && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const panelWidth = 196;
      let left = rect.left + rect.width / 2 - panelWidth / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - panelWidth - 8));
      setPanelStyle({
        position: 'fixed',
        top: rect.bottom + 6,
        left,
        zIndex: 99999,
      });
    }
    setIsOpen(prev => !prev);
  };

  const handlePick = (color) => {
    onSelect(color);
    setIsOpen(false);
  };

  return (
    <div className="color-picker-wrapper" ref={wrapperRef}>
      <button
        type="button"
        className={`toolbar-btn toolbar-color-btn ${swatchExtraClass || ''}`}
        data-tooltip={label}
        aria-label={label}
        onMouseDown={(e) => e.preventDefault()}
        onClick={handleToggle}
      >
        <span className="toolbar-color-icon">{icon}</span>
        <span
          className={`toolbar-color-fill ${currentColor === 'transparent' ? 'no-color-swatch' : ''}`}
          style={{ backgroundColor: currentColor === 'transparent' ? '#fff' : currentColor }}
        />
      </button>

      {isOpen && (
        <div className="color-picker-panel" style={panelStyle}>
          <div className="color-picker-grid">
            {colors?.map(c => (
              <button
                type="button"
                key={c.value}
                className={`color-picker-swatch-btn ${c.value === 'transparent' ? 'no-color-swatch' : ''} ${currentColor === c.value ? 'selected' : ''}`}
                style={{ backgroundColor: c.value === 'transparent' ? '#1f1f1f' : c.value }}
                title={c.label}
                aria-label={c.label}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handlePick(c.value)}
              >
                {currentColor === c.value && (
                  <svg className="color-picker-check" viewBox="0 0 24 24" width="16" height="16">
                    <path d="M4 12.5l5 5L20 6.5" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function FontSizeDropdown({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [panelStyle, setPanelStyle] = useState({});
  const wrapperRef = useRef(null);
  const sizes = [10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 28, 32, 36, 48, 72];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isOpen && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPanelStyle({
        position: 'fixed',
        top: rect.bottom + 5,
        left: rect.left + rect.width / 2,
        transform: 'translateX(-50%)',
        zIndex: 99999,
      });
    }
    setIsOpen(prev => !prev);
  };

  return (
    <div className="fontsize-picker-wrapper" ref={wrapperRef}>
      <button
        type="button"
        className="fontsize-picker-btn"
        onMouseDown={(e) => e.preventDefault()}
        onClick={handleToggle}
      >
        <span>{value}px</span>
        <svg width="9" height="5" viewBox="0 0 9 5" fill="none">
          <path d="M1 1l3.5 3L8 1" stroke="#999" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
      {isOpen && (
        <div className="fontsize-picker-panel" style={panelStyle}>
          {sizes?.map(s => (
            <button
              key={s}
              type="button"
              className={`fontsize-picker-option ${String(s) === String(value) ? 'selected' : ''}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => { onChange(String(s)); setIsOpen(false); }}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function DocumentEditor({ previewData, stateIds, docTypeIds, onSave, onReset, selectedCondition, isIntake, versionXml, highlightClauseText }) {
  const editorRef = useRef(null);
  const pageWrapperRef = useRef(null);
  const [fontSize, setFontSize] = useState('14');
  const [fontColor, setFontColor] = useState('#000000');
  const [highlightColor, setHighlightColor] = useState('#ffff00');
  const [isMaximized, setIsMaximized] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const originalHtmlMap = useRef({});
  const originalStyleMap = useRef({});
  const [notifApi, notifContextHolder] = notification.useNotification();
  const savedSelectionRef = useRef(null);
  const [pageJumpInput, setPageJumpInput] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchPanelStyle, setSearchPanelStyle] = useState({});
  const searchInputRef = useRef(null);
  const searchWrapperRef = useRef(null);

  const getPageWindow = (current, total) => {
    if (total <= 9) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = new Set([1, 2, total - 1, total]);
    for (let p = current - 1; p <= current + 1; p++) {
      if (p >= 1 && p <= total) pages.add(p);
    }

    const sorted = Array.from(pages)?.sort((a, b) => a - b);
    const withEllipses = [];
    sorted?.forEach((p, idx) => {
      if (idx > 0 && p - sorted[idx - 1] > 1) {
        withEllipses.push('ellipsis-' + p);
      }
      withEllipses.push(p);
    });
    return withEllipses;
  };

  const handlePageJumpSubmit = (e) => {
    e.preventDefault();
    const num = parseInt(pageJumpInput, 10);
    if (num >= 1 && num <= pageCount) {
      scrollToPage(num);
    }
    setPageJumpInput('');
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim()?.length < 2) {
      setSearchResults([]);
      setIsSearchOpen(false);
      return;
    }
    const results = searchInDocument(term.trim());
    setSearchResults(results);
    if (results?.length > 0 && searchWrapperRef.current) {
      const rect = searchWrapperRef.current.getBoundingClientRect();
      const panelWidth = 400;
      let leftPos = rect.left;
      if (leftPos + panelWidth > window.innerWidth - 8) {
        leftPos = window.innerWidth - panelWidth - 8;
      }
      setSearchPanelStyle({
        position: 'fixed',
        top: rect.bottom + 6,
        left: Math.max(8, leftPos),
        width: panelWidth,
        zIndex: 99999,
      });
    }
    setIsSearchOpen(results?.length > 0);
  };

  const searchInDocument = (term) => {
    if (!previewData || !previewData.sections) return [];
    const lowerTerm = term.toLowerCase();
    const matches = [];

    previewData.sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => {
        const textContent = (para.html || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
        if (textContent.toLowerCase()?.includes(lowerTerm)) {
          const idx = textContent.toLowerCase().indexOf(lowerTerm);
          const snippetStart = Math.max(0, idx - 40);
          const snippetEnd = Math.min(textContent?.length, idx + term?.length + 60);
          let snippet = textContent.slice(snippetStart, snippetEnd).trim();
          if (snippetStart > 0) snippet = '…' + snippet;
          if (snippetEnd < textContent?.length) snippet = snippet + '…';

          matches.push({
            paraId: para.id,
            sourceFile: para.sourceFile,
            snippet,
            matchIndex: idx,
            term,
          });
        }
      });
    });

    return matches.slice(0, 20);
  };

  const handleSearchResultClick = (result) => {
    if (!editorRef.current || !pageWrapperRef.current) return;

    editorRef.current.querySelectorAll('.doc-search-highlight')?.forEach(el => {
      el.classList.remove('doc-search-highlight');
    });

    const paraEl = editorRef.current.querySelector(`[data-para-id="${result.paraId}"]`);
    if (!paraEl) return;

    paraEl.classList.add('doc-search-highlight');

    const pageEl = paraEl.closest('.doc-a4-page');
    if (pageEl) {
      const pageNum = Number(pageEl.getAttribute('data-page'));
      setActivePage(pageNum);
    }

    const wrapperRect = pageWrapperRef.current.getBoundingClientRect();
    const paraRect = paraEl.getBoundingClientRect();
    const currentScroll = pageWrapperRef.current.scrollTop;
    const targetScrollTop = currentScroll + (paraRect.top - wrapperRect.top) - 80;
    pageWrapperRef.current.scrollTo({ top: targetScrollTop, behavior: 'smooth' });

    setTimeout(() => {
      paraEl.classList.remove('doc-search-highlight');
    }, 3000);

    setIsSearchOpen(false);
    setSearchTerm('');
    setSearchResults([]);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsSearchOpen(false);
      setSearchTerm('');
      setSearchResults([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchWrapperRef.current && !searchWrapperRef.current.contains(e.target) &&
        !e.target.closest('.doc-search-results-panel')
      ) {
        setIsSearchOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const highlightSearchTerm = (text, term) => {
    if (!term) return text;
    const regex = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    return parts?.map((part, i) =>
      regex.test(part)
        ? <mark key={i} className="doc-search-match-highlight">{part}</mark>
        : part
    );
  };

  const updatePageCount = useCallback(() => {
    if (!editorRef.current) return;
    const pageEls = editorRef.current.querySelectorAll('.doc-a4-page');
    if (pageEls?.length > 0) {
      setPageCount(pageEls?.length);
    } else {
      const manualBreaks = editorRef.current.querySelectorAll('.doc-page-break')?.length || 0;
      const contentHeight = editorRef.current.scrollHeight;
      const heightBasedPages = Math.max(1, Math.ceil(contentHeight / A4_HEIGHT_PX));
      setPageCount(Math.max(heightBasedPages, manualBreaks + 1));
    }
  }, []);

  const handlePageWrapperScroll = useCallback(() => {
    if (!editorRef.current || !pageWrapperRef.current) return;

    const wrapperRect = pageWrapperRef.current.getBoundingClientRect();
    const wrapperMid = wrapperRect.top + 80;

    const pageEls = editorRef.current.querySelectorAll('.doc-a4-page');
    if (pageEls?.length > 0) {
      let activePg = 1;
      pageEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top <= wrapperMid) {
          activePg = Number(el.getAttribute('data-page'));
        }
      });
      setActivePage(activePg);
    } else {
      const editorTop = editorRef.current.getBoundingClientRect().top;
      const scrolledIntoContent = wrapperRect.top - editorTop;
      const page = Math.min(pageCount, Math.max(1, Math.floor(scrolledIntoContent / A4_HEIGHT_PX) + 1));
      setActivePage(page);
    }
  }, [pageCount]);

  const scrollToPage = useCallback((pageNum) => {
    if (!pageWrapperRef.current || !editorRef.current) return;
    setActivePage(pageNum);
    const pageEl = editorRef.current.querySelector(`.doc-a4-page[data-page="${pageNum}"]`);
    if (pageEl) {
      const wrapperRect = pageWrapperRef.current.getBoundingClientRect();
      const pageRect = pageEl.getBoundingClientRect();
      const currentScroll = pageWrapperRef.current.scrollTop;
      const targetScrollTop = currentScroll + (pageRect.top - wrapperRect.top) - 32;
      pageWrapperRef.current.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
    } else {
      const editorTop = editorRef.current.offsetTop;
      const targetOffset = editorTop + (pageNum - 1) * A4_HEIGHT_PX;
      pageWrapperRef.current.scrollTo({ top: targetOffset, behavior: 'smooth' });
    }
  }, []);

  const toUpperRoman = (num) => {
    if (num <= 0) return '';
    const map = [
      [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'], [100, 'C'], [90, 'XC'],
      [50, 'L'], [40, 'XL'], [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I'],
    ];
    let n = num, out = '';
    for (const [val, sym] of map) {
      while (n >= val) { out += sym; n -= val; }
    }
    return out;
  };

  const getParaRestart = (para) => {
    const m = para.html?.match(/data-restart-value=['"](\d+)['"]/);
    return m ? parseInt(m[1], 10) : null;
  };

  const getParaRestartArticle = (para) => {
    const m = para.html?.match(/data-restart-article=['"](\d+)['"]/);
    return m ? parseInt(m[1], 10) : null;
  };

  const getRestartAttrs = (block) => {
    let attrs = '';
    const restartValue = block.getAttribute('data-restart-value');
    const restartArticle = block.getAttribute('data-restart-article');
    if (restartValue) attrs += ` data-restart-value="${restartValue}"`;
    if (restartArticle) attrs += ` data-restart-article="${restartArticle}"`;
    return attrs;
  };

  const toLowerRoman = (num) => toUpperRoman(num).toLowerCase();

  const toLowerAlpha = (num) => {
    if (num <= 0) return '';
    let n = num, out = '';
    while (n > 0) {
      const rem = (n - 1) % 26;
      out = String.fromCharCode(97 + rem) + out;
      n = Math.floor((n - 1) / 26);
    }
    return out;
  };

  const alphaToNum = (str) => {
    let n = 0;
    for (let i = 0; i < str.length; i++) {
      n = n * 26 + (str.toLowerCase().charCodeAt(i) - 96);
    }
    return n;
  };

  const romanToNum = (str) => {
    const map = { I: 1, V: 5, X: 10, L: 50, C: 100, D: 500, M: 1000 };
    const s = str.toUpperCase();
    let total = 0;
    for (let i = 0; i < s.length; i++) {
      const curr = map[s[i]] || 0;
      const next = map[s[i + 1]] || 0;
      total += curr < next ? -curr : curr;
    }
    return total;
  };

  const COUNTER_CLASSES = [
    'doc-numbered',
    'doc-article1-heading',
    'doc-article1-sub',
    'doc-article8-heading',
    'doc-article8-subsub',
    'doc-numbered-alpha',
    'doc-numbered-alpha-upper',
    'doc-numbered-roman',
    'doc-numbered-roman-upper',
  ];

  const PRIORITY_COUNTER_CLASSES = [
    'doc-numbered-roman-upper',
    'doc-numbered-roman',
    'doc-numbered-alpha-upper',
    'doc-numbered-alpha',
    'doc-article8-subsub',
    'doc-article1-sub',
    'doc-article8-heading',
    'doc-article1-heading',
    'doc-numbered',
  ];

  const syncCounterLabels = useCallback(() => {
    if (!editorRef.current) return;

    let docNum = 0, docArticle1 = 0, docArticle1Sub = 0;
    let docArticle8 = 0, docArticle8SubSub = 0;
    let docAlpha = 0, docAlphaUpper = 0, docRoman = 0, docRomanUpper = 0;

    const blocks = editorRef.current.querySelectorAll('.doc-editor-block');

    blocks.forEach(block => {
      if (block.closest('td, th')) return;

      const cls = PRIORITY_COUNTER_CLASSES.find(c => block.classList.contains(c));

      switch (cls) {
        case 'doc-numbered':
          docNum += 1; docAlpha = 0; docAlphaUpper = 0; docRoman = 0; docRomanUpper = 0;
          block.setAttribute('data-counter-label', `${docNum}. `);
          break;
        case 'doc-article1-heading':
          docArticle1 += 1; docArticle1Sub = 0;
          block.setAttribute('data-counter-label', `ARTICLE ${toUpperRoman(docArticle1)}  `);
          break;
        case 'doc-article1-sub': {
          const restartArticle = block.getAttribute('data-restart-article');
          const restartValue = block.getAttribute('data-restart-value');
          if (restartArticle) {
            docArticle1 = parseInt(restartArticle, 10);
          }
          docArticle1Sub = restartValue ? parseInt(restartValue, 10) : docArticle1Sub + 1;
          block.setAttribute('data-counter-label', `${docArticle1}.${docArticle1Sub}  `);
          break;
        }
        case 'doc-article8-heading':
          docArticle8 += 1; docArticle8SubSub = 0;
          block.setAttribute('data-counter-label', `Article ${toUpperRoman(docArticle8)}  `);
          break;
        case 'doc-article8-subsub':
          docArticle8SubSub += 1;
          block.setAttribute('data-counter-label', `(${toLowerAlpha(docArticle8SubSub)})  `);
          break;
        case 'doc-numbered-alpha':
          docAlpha += 1;
          block.setAttribute('data-counter-label', `${toLowerAlpha(docAlpha)}. `);
          break;
        case 'doc-numbered-alpha-upper':
          docAlphaUpper += 1;
          block.setAttribute('data-counter-label', `${toLowerAlpha(docAlphaUpper).toUpperCase()}. `);
          break;
        case 'doc-numbered-roman':
          docRoman += 1;
          block.setAttribute('data-counter-label', `${toLowerRoman(docRoman)}. `);
          break;
        case 'doc-numbered-roman-upper':
          docRomanUpper += 1;
          block.setAttribute('data-counter-label', `${toUpperRoman(docRomanUpper)}. `);
          break;
        default:
          break;
      }
    });
  }, []);

  useEffect(() => {
    console.log('DocumentEditor useEffect triggered', {
      hasEditorRef: !!editorRef.current,
      hasPreviewData: !!previewData,
      hasVersionXml: !!versionXml,
      versionXmlLength: versionXml?.length,
      docTypeIds,
    });

    if (!editorRef.current) return;

    if (versionXml) {
      const versionHtml = buildVersionHtml(versionXml);
      editorRef.current.innerHTML = versionHtml;
      editorRef.current.setAttribute('contenteditable', 'false');
      if (pageWrapperRef.current) pageWrapperRef.current.scrollTop = 0;
      updatePageCount();
      setActivePage(1);
      return;
    }

    if (!previewData) return;
    editorRef.current.setAttribute('contenteditable', 'true');
    const html = buildEditableHtml(selectedCondition);
    const docStyles = getDocumentStyles();

    if (!selectedCondition && docStyles) {
      editorRef.current.innerHTML = `<style>${docStyles}</style>` + html;
    } else {
      editorRef.current.innerHTML = html;
    }

    if (pageWrapperRef.current) {
      pageWrapperRef.current.scrollTop = 0;
    }

    const map = {};
    const styleMap = {};
    const seenCount = {};
    (previewData?.sections || [])?.forEach(section => {
      (section?.paragraphs || [])?.forEach(para => {
        const compositeKey = `${para.id}::${para.sourceFile}`;
        const count = seenCount[para.id] || 0;
        seenCount[para.id] = count + 1;
        const allMatchingEls = editorRef.current.querySelectorAll(`[data-para-id="${para.id}"]`);
        const el = allMatchingEls[count];
        if (el) {
          map[compositeKey] = normalizeHtml(el.innerHTML);
          styleMap[compositeKey] = el.style.cssText || '';
        }
      });
    });
    originalHtmlMap.current = map;
    originalStyleMap.current = styleMap;
    updatePageCount();
    setActivePage(1);
  }, [previewData, selectedCondition, versionXml]);

  useEffect(() => {
    if (!highlightClauseText || !editorRef.current || !pageWrapperRef.current) return;

    const getPlainText = (el) => (el.textContent || '').replace(/\u00A0/g, ' ');

    const blocks = editorRef.current.querySelectorAll('.doc-editor-block');
    let target = null;
    for (const block of blocks) {
      if (getPlainText(block).includes(highlightClauseText)) {
        target = block;
        break;
      }
    }
    if (!target) return;

    editorRef.current.querySelectorAll('.doc-search-highlight')?.forEach(el => {
      el.classList.remove('doc-search-highlight');
    });
    target.classList.add('doc-search-highlight');

    const pageEl = target.closest('.doc-a4-page');
    if (pageEl) setActivePage(Number(pageEl.getAttribute('data-page')));

    const wrapperRect = pageWrapperRef.current.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const currentScroll = pageWrapperRef.current.scrollTop;
    const targetScrollTop = currentScroll + (targetRect.top - wrapperRect.top) - 80;
    pageWrapperRef.current.scrollTo({ top: targetScrollTop, behavior: 'smooth' });

    const t = setTimeout(() => {
      target.classList.remove('doc-search-highlight');
    }, 3000);
    return () => clearTimeout(t);
  }, [highlightClauseText, previewData, selectedCondition, versionXml]);

  useEffect(() => {
    if (!editorRef.current) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (!node.classList?.contains('doc-editor-block')) return;
          const id = node.getAttribute('data-para-id');
          if (!id) return;
          const siblings = editorRef.current.querySelectorAll(`[data-para-id="${id}"]`);
          if (siblings?.length > 1) {
            node.removeAttribute('data-para-id');
            node.removeAttribute('data-source-file');
          }
        });
      });
      updatePageCount();
      syncCounterLabels();
    });
    observer.observe(editorRef.current, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [updatePageCount, syncCounterLabels]);

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
  };

  const handleBold = () => execCommand('bold');
  const handleItalic = () => execCommand('italic');
  const handleUnderline = () => execCommand('underline');
  const handleStrikethrough = () => execCommand('strikeThrough');
  const handleAlignLeft = () => execCommand('justifyLeft');
  const handleAlignCenter = () => execCommand('justifyCenter');
  const handleAlignRight = () => execCommand('justifyRight');
  const handleAlignJustify = () => execCommand('justifyFull');

  const handleFontSize = (size) => {
    setFontSize(size);
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0 || selection.isCollapsed) return;

    const range = selection.getRangeAt(0);
    execCommand('fontSize', '7');

    const container = range.commonAncestorContainer.nodeType === Node.ELEMENT_NODE
      ? range.commonAncestorContainer
      : range.commonAncestorContainer.parentElement;

    container.querySelectorAll('font[size="7"]')?.forEach(el => {
      const span = document.createElement('span');
      span.style.fontSize = size + 'px';
      while (el.firstChild) span.appendChild(el.firstChild);
      el.parentNode?.replaceChild(span, el);
    });

    editorRef.current?.focus();
  };

  const handleEditorSelect = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0 && editorRef.current?.contains(selection.anchorNode)) {
      savedSelectionRef.current = selection.getRangeAt(0).cloneRange();
    }
  };

  const restoreSelection = () => {
    if (!savedSelectionRef.current) return false;
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(savedSelectionRef.current);
    return true;
  };

  const applyInlineStyleToRange = (sourceRange, styleProp, styleValue) => {
    const editor = editorRef.current;
    if (!editor || !sourceRange || sourceRange.collapsed) return null;
    const range = sourceRange.cloneRange();

    const plans = [];
    Array.from(editor.children)?.forEach(block => {
      if (block.nodeType !== Node.ELEMENT_NODE) return;
      if (block.tagName === 'STYLE') return;
      if (block.classList?.contains('doc-page-break')) return;

      const blockRange = document.createRange();
      blockRange.selectNodeContents(block);

      const intersects =
        range.compareBoundaryPoints(Range.START_TO_END, blockRange) <= 0 &&
        range.compareBoundaryPoints(Range.END_TO_START, blockRange) >= 0;
      if (!intersects) return;

      const startsInsideBlock = range.compareBoundaryPoints(Range.START_TO_START, blockRange) > 0;
      const endsInsideBlock = range.compareBoundaryPoints(Range.END_TO_END, blockRange) < 0;

      plans.push({
        startContainer: startsInsideBlock ? range.startContainer : block,
        startOffset: startsInsideBlock ? range.startOffset : 0,
        endContainer: endsInsideBlock ? range.endContainer : block,
        endOffset: endsInsideBlock ? range.endOffset : block.childNodes?.length,
      });
    });

    if (!plans?.length) return null;

    let lastSpan = null;
    plans?.forEach(plan => {
      const subRange = document.createRange();
      subRange.setStart(plan.startContainer, plan.startOffset);
      subRange.setEnd(plan.endContainer, plan.endOffset);
      if (subRange.collapsed) return;

      const span = document.createElement('span');
      span.style[styleProp] = styleValue;
      span.setAttribute('data-color-span', '1');
      const extracted = subRange.extractContents();
      extracted.querySelectorAll('[data-color-span]')?.forEach(el => {
        el.style.removeProperty('font-family');
        el.style.removeProperty('font-size');
        if (!el.style.cssText.trim()) el.removeAttribute('style');
      });

      span.appendChild(extracted);
      subRange.insertNode(span);

      span.style.removeProperty('font-family');
      span.style.removeProperty('font-size');
      span.style[styleProp] = styleValue;

      lastSpan = span;
    });

    return lastSpan;
  };

  const reselectSpan = (span) => {
    if (!span) return;
    const selection = window.getSelection();
    const newRange = document.createRange();
    newRange.selectNodeContents(span);
    selection.removeAllRanges();
    selection.addRange(newRange);
    savedSelectionRef.current = newRange.cloneRange();
  };

  const handleFontColor = (color) => {
    setFontColor(color);
    editorRef.current?.focus();
    const range = savedSelectionRef.current;
    const span = applyInlineStyleToRange(range, 'color', color);
    if (span) {
      reselectSpan(span);
    } else if (range && !range.collapsed) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range.cloneRange());
      execCommand('foreColor', color);
    }
  };

  const handleHighlight = (color) => {
    setHighlightColor(color);
    editorRef.current?.focus();
    const range = savedSelectionRef.current;
    const span = applyInlineStyleToRange(range, 'backgroundColor', color);
    if (span) {
      reselectSpan(span);
    } else if (range && !range.collapsed) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range.cloneRange());
      execCommand('hiliteColor', color === 'transparent' ? 'transparent' : color);
    }
  };

  const handleUndo = () => execCommand('undo');
  const handleRedo = () => execCommand('redo');

  const handleInsertPageBreak = () => {
    const editor = editorRef.current;
    if (!editor) return;

    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      if (editor?.contains(range?.startContainer)) {
        const pageBreak = document.createElement('div');
        pageBreak.className = 'doc-page-break';
        pageBreak.setAttribute('contenteditable', 'false');
        pageBreak.innerHTML = '<span class="page-break-label">— Page Break —</span><span class="page-break-remove">×</span>';
        range.deleteContents();
        range.insertNode(pageBreak);
        const newRange = document.createRange();
        newRange.setStartAfter(pageBreak);
        newRange.collapse(true);
        selection.removeAllRanges();
        selection.addRange(newRange);
        editor.focus();
        return;
      }
    }
    const pageBreak = document.createElement('div');
    pageBreak.className = 'doc-page-break';
    pageBreak.setAttribute('contenteditable', 'false');
    pageBreak.innerHTML = '<span class="page-break-label">— Page Break —</span><span class="page-break-remove">×</span>';
    editor.appendChild(pageBreak);
    editor.focus();
  };

  const handleEditorClick = (e) => {
    if (e.target.classList?.contains('page-break-remove')) {
      const pageBreak = e.target?.closest('.doc-page-break');
      if (pageBreak) pageBreak?.remove();
    }
  };

  const handleEditorKeyDown = (e) => {
    const editor = editorRef.current;
    if (!editor) return;

    if (e.key === ' ') {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0 && editor.contains(selection.getRangeAt(0).startContainer)) {
        const range = selection.getRangeAt(0);
        let blockEl = range.startContainer.nodeType === Node.ELEMENT_NODE
          ? range.startContainer
          : range.startContainer.parentElement;
        blockEl = blockEl?.closest('.doc-editor-block');

        if (blockEl && !blockEl.classList.contains('doc-heading-locked') && !blockEl.classList.contains('doc-table-block')) {
          const trimmed = (blockEl.textContent || '').replace(/\u00A0/g, ' ').trim();
          const romanBody = trimmed.replace(/\.$/, '');
          const subMatch = trimmed.match(/^(\d+)\.(\d+)\.?$/);

          let targetClass = null;
          if (/^\d+\.$/.test(trimmed)) {
            targetClass = 'doc-numbered';
          } else if (subMatch) {
            targetClass = 'doc-article1-sub';
          } else if (/^[ivxlcdm]+\.$/i.test(trimmed) && romanBody.length >= 1) {
            targetClass = /[A-Z]/.test(romanBody) ? 'doc-numbered-roman-upper' : 'doc-numbered-roman';
          } else if (/^[a-z]\.$/.test(trimmed)) {
            targetClass = 'doc-numbered-alpha';
          } else if (/^[A-Z]\.$/.test(trimmed)) {
            targetClass = 'doc-numbered-alpha-upper';
          }

          if (targetClass) {
            e.preventDefault();
            let restartValue = null;
            if (targetClass === 'doc-numbered') {
              restartValue = parseInt(trimmed.replace(/\.$/, ''), 10);
            } else if (targetClass === 'doc-numbered-alpha' || targetClass === 'doc-numbered-alpha-upper') {
              restartValue = alphaToNum(trimmed.replace(/\.$/, ''));
            } else if (targetClass === 'doc-numbered-roman' || targetClass === 'doc-numbered-roman-upper') {
              restartValue = romanToNum(romanBody);
            } else if (targetClass === 'doc-article1-sub' && subMatch) {
              restartValue = parseInt(subMatch[2], 10);
              blockEl.setAttribute('data-restart-article', subMatch[1]);
            }

            COUNTER_CLASSES.forEach(c => blockEl.classList.remove(c));
            blockEl.classList.remove('doc-para');
            blockEl.classList.add(targetClass);
            if (restartValue && restartValue > 0) {
              blockEl.setAttribute('data-restart-value', restartValue);
            }
            blockEl.innerHTML = '<br>';
            syncCounterLabels();

            const newRange = document.createRange();
            newRange.setStart(blockEl, 0);
            newRange.collapse(true);
            selection.removeAllRanges();
            selection.addRange(newRange);
            return;
          }
        }
      }
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;
      const range = selection.getRangeAt(0);
      if (!editor.contains(range.startContainer)) return;

      let blockEl = range.startContainer.nodeType === Node.ELEMENT_NODE
        ? range.startContainer
        : range.startContainer.parentElement;
      blockEl = blockEl?.closest('.doc-editor-block');

      if (!blockEl) {
        return;
      }
      if (blockEl.classList.contains('doc-heading-locked') || blockEl.classList.contains('doc-table-block')) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      const splitRange = document.createRange();
      splitRange.setStart(range.startContainer, range.startOffset);
      splitRange.setEndAfter(blockEl.lastChild || blockEl);
      const fragment = splitRange.extractContents();

      const originalCounterClass = PRIORITY_COUNTER_CLASSES.find(c => blockEl.classList.contains(c));
      const LIST_CONTINUATION_CLASSES = ['doc-numbered', 'doc-numbered-alpha', 'doc-numbered-alpha-upper', 'doc-numbered-roman', 'doc-numbered-roman-upper', 'doc-article8-subsub', 'doc-article1-sub',];
      const shouldContinueNumbering = LIST_CONTINUATION_CLASSES.includes(originalCounterClass);

      const nonCounterClasses = Array.from(blockEl.classList).filter(
        c => !COUNTER_CLASSES.includes(c)
      );

      const newBlock = document.createElement('div');
      newBlock.className = nonCounterClasses.join(' ');
      if (shouldContinueNumbering) {
        newBlock.classList.add(originalCounterClass);
      } else if (originalCounterClass) {
        newBlock.classList.add('doc-numbered-continuation');
      }
      newBlock.appendChild(fragment);
      if (!newBlock.textContent.trim()) {
        newBlock.innerHTML = '<br>';
      }

      blockEl.parentNode.insertBefore(newBlock, blockEl.nextSibling);
      syncCounterLabels();
      const newRange = document.createRange();
      newRange.setStart(newBlock, 0);
      newRange.collapse(true);
      selection.removeAllRanges();
      selection.addRange(newRange);
      return;
    }

    if (e.key === 'Backspace') {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (range.collapsed && editor.contains(range.startContainer)) {
          let blockEl = range.startContainer.nodeType === Node.ELEMENT_NODE
            ? range.startContainer
            : range.startContainer.parentElement;
          blockEl = blockEl?.closest('.doc-editor-block');

          if (blockEl) {
            const hasCounterClass = COUNTER_CLASSES.some(c => blockEl.classList.contains(c));
            const isEmptyBlock = !blockEl.textContent || !blockEl.textContent.replace(/\u00A0/g, '').trim();
            const isAtStart = range.startOffset === 0;

            if (hasCounterClass && isEmptyBlock && isAtStart && !blockEl.classList.contains('doc-heading-locked')) {
              e.preventDefault();
              COUNTER_CLASSES.forEach(c => blockEl.classList.remove(c));
              blockEl.removeAttribute('data-restart-value');
              blockEl.removeAttribute('data-restart-article');
              blockEl.classList.add('doc-para');
              syncCounterLabels();
              const newRange = document.createRange();
              newRange.setStart(blockEl, 0);
              newRange.collapse(true);
              selection.removeAllRanges();
              selection.addRange(newRange);
              return;
            }
          }
        }
      }
    }

    if (e.key === 'Backspace' || e.key === 'Delete') {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);

        if (!range.collapsed) {
          const fragment = range.cloneContents();
          const placeholders = fragment.querySelectorAll('.will-placeholder, .para-locked-text');
          if (placeholders?.length > 0) {
            e.preventDefault();
            return;
          }
        }

        if (range.collapsed) {
          let targetNode = null;

          if (e.key === 'Backspace') {
            const container = range.startContainer;
            const offset = range.startOffset;

            if (container.nodeType === Node.ELEMENT_NODE && offset > 0) {
              const prevChild = container.childNodes[offset - 1];
              if (prevChild && prevChild.classList &&
                (prevChild.classList?.contains('will-placeholder') || prevChild.classList?.contains('para-locked-text'))) {
                e.preventDefault();
                return;
              }
              if (prevChild && prevChild.classList && prevChild.classList?.contains('doc-page-break')) {
                targetNode = prevChild;
              }
            } else if (container.nodeType === Node.TEXT_NODE && range.startOffset === 0) {
              const prevSibling = container.previousSibling;
              if (prevSibling && prevSibling.nodeType === Node.ELEMENT_NODE &&
                (prevSibling.classList?.contains('will-placeholder') || prevSibling.classList?.contains('para-locked-text'))) {
                e.preventDefault();
                return;
              }
              const parentBlock = container.parentElement?.closest('.doc-editor-block, .doc-page-break');
              if (parentBlock) {
                const prev = parentBlock.previousElementSibling;
                if (prev && prev.classList?.contains('doc-page-break')) {
                  targetNode = prev;
                }
              }
            }
          } else if (e.key === 'Delete') {
            const container = range.startContainer;
            const offset = range.startOffset;

            if (container.nodeType === Node.ELEMENT_NODE && offset < container.childNodes?.length) {
              const nextChild = container.childNodes[offset];
              if (nextChild && nextChild.classList &&
                (nextChild.classList?.contains('will-placeholder') || nextChild.classList?.contains('para-locked-text'))) {
                e.preventDefault();
                return;
              }
              if (nextChild && nextChild.classList && nextChild.classList?.contains('doc-page-break')) {
                targetNode = nextChild;
              }
            } else if (container.nodeType === Node.TEXT_NODE && range.startOffset === container.textContent?.length) {
              const nextSibling = container.nextSibling;
              if (nextSibling && nextSibling.nodeType === Node.ELEMENT_NODE &&
                (nextSibling.classList?.contains('will-placeholder') || nextSibling.classList?.contains('para-locked-text'))) {
                e.preventDefault();
                return;
              }
              const parentBlock = container.parentElement?.closest('.doc-editor-block, .doc-page-break');
              if (parentBlock) {
                const next = parentBlock.nextElementSibling;
                if (next && next.classList?.contains('doc-page-break')) {
                  targetNode = next;
                }
              }
            }
          }

          if (targetNode) {
            e.preventDefault();
            targetNode.remove();
          }
        }
      }
    }
  };

  const handleToolbarMouseDown = (e) => {
    if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION' || e.target.tagName === 'INPUT') return;
    e.preventDefault();
  };

  const getTextWithBreaks = (el) => {
    if (!el) return '';
    const clone = el.cloneNode(true);
    const lines = clone.querySelectorAll('.doc-line');
    lines.forEach((line, idx) => {
      if (idx < lines.length - 1) {
        line.insertAdjacentText('afterend', ' ');
      }
    });
    clone.querySelectorAll('br').forEach(br => {
      br.replaceWith(' ');
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const handleSave = useCallback(() => {
    if (!editorRef.current || !previewData) return;

    const sections = previewData.sections || [];
    const allParagraphs = [];

    const paraOccurrences = {};
    sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => {
        if (!paraOccurrences[para.id]) paraOccurrences[para.id] = [];
        paraOccurrences[para.id]?.push({ section, para });
      });
    });

    const classToStyleMap = {};
    sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => {
        const m = para.html?.match(/class=['"]([^'"]+)['"]/);
        const cls = m ? m[1] : null;
        if (cls && para.style && !classToStyleMap[cls]) {
          classToStyleMap[cls] = para.style;
        }
      });
    });

    const paraSeenCount = {};
    const allChildren = Array.from(editorRef.current.querySelectorAll(
      ':scope > .doc-editor-block, :scope > .doc-a4-page > .doc-editor-block, :scope > .doc-page-break'
    ));
    let lastKnownParaId = null;
    let lastKnownSourceFile = null;
    const foundParaKeys = new Set();

    allChildren?.forEach(block => {
      if (block.classList?.contains('doc-page-break')) return;
      if (block.tagName === 'STYLE') return;

      const paraId = block?.getAttribute('data-para-id');

      if (paraId && paraOccurrences[paraId]) {
        const occurrenceIndex = paraSeenCount[paraId] || 0;
        const occurrence = paraOccurrences[paraId][occurrenceIndex];

        const isClonedBlock = occurrence &&
          lastKnownParaId === paraId &&
          occurrence.para.sourceFile !== lastKnownSourceFile;

        if (!occurrence || isClonedBlock) {
          if (lastKnownParaId) {
            let inlineStyle = '';
            if (block.style && block.style.cssText) {
              inlineStyle = ` style="${block.style.cssText}"`;
            }
            const content = getTextWithBreaks(block);
            const currentClass = (block.className || '')
              .replace('doc-editor-block', '')
              .replace('doc-heading-locked', '')
              .split(' ')
              .filter(c => c && c !== 'doc-para')
              .join(' ')
              || 'doc-para';
            const resolvedStyle = classToStyleMap[currentClass] || 'para-body';
            if (content.trim() || block.innerHTML.trim()) {
              allParagraphs.push({
                id: lastKnownParaId,
                style: resolvedStyle,
                sourceFile: lastKnownSourceFile || '',
                content: content,
                html: `<p class='${currentClass}'${inlineStyle}${getRestartAttrs(block)}>${block?.innerHTML}</p>`,
                operation: 'insert_after',
              });
            }
          }
          if (!isClonedBlock) {
            paraSeenCount[paraId] = occurrenceIndex + 1;
            const lastOccurrence = paraOccurrences[paraId][paraOccurrences[paraId]?.length - 1];
            if (lastOccurrence) lastKnownSourceFile = lastOccurrence.para.sourceFile;
            lastKnownParaId = paraId;
          }
          return;
        }

        paraSeenCount[paraId] = occurrenceIndex + 1;

        const { para: paraData } = occurrence;
        const paraKey = `${paraData.id}::${paraData.sourceFile}`;
        foundParaKeys.add(paraKey);

        const currentHtml = normalizeHtml(block.innerHTML);
        const originalInner = originalHtmlMap.current[paraKey];

        const currentStyle = block.style?.cssText || '';
        const originalStyle = originalStyleMap.current[paraKey] || '';
        const styleChanged = currentStyle !== originalStyle;

        if (currentHtml !== originalInner || styleChanged) {
          allParagraphs.push({
            id: paraData.id,
            style: paraData.style,
            sourceFile: paraData.sourceFile,
            content: getTextWithBreaks(block),
            html: wrapWithTag(paraData, currentHtml, block),
            operation: 'update',
          });
        }

        lastKnownParaId = paraId;
        lastKnownSourceFile = paraData.sourceFile;

      } else if (block.nodeType === Node.ELEMENT_NODE) {
        if (lastKnownParaId) {
          let inlineStyle = '';
          if (block.style && block.style.cssText) {
            inlineStyle = ` style="${block.style.cssText}"`;
          }
          const content = getTextWithBreaks(block);
          const currentClass = (block.className || '')
            .replace('doc-editor-block', '')
            .replace('doc-heading-locked', '')
            .trim() || 'doc-para';
          const resolvedStyle = classToStyleMap[currentClass] || 'para-body';
          if (content.trim() || block.innerHTML.trim()) {
            allParagraphs.push({
              id: lastKnownParaId,
              style: resolvedStyle,
              sourceFile: lastKnownSourceFile || '',
              content: content,
              html: `<p class='${currentClass}'${inlineStyle}${getRestartAttrs(block)}>${block?.innerHTML}</p>`,
              operation: 'insert_after',
            });
          }
        }
      }
    });

    sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => {
        const paraKey = `${para.id}::${para.sourceFile}`;
        const wasRendered = Object.prototype.hasOwnProperty.call(originalHtmlMap.current, paraKey);
        if (wasRendered && !foundParaKeys.has(paraKey)) {
          allParagraphs.push({
            id: para.id,
            style: para.style,
            sourceFile: para.sourceFile,
            content: '',
            html: '',
            operation: 'delete',
          });
        }
      });
    });

    if (allParagraphs?.length === 0) {
      notifApi.warning({ message: 'No changes detected.', placement: 'topRight' });
      return;
    }

    const changedParaMap = {};
    allParagraphs?.forEach(p => {
      if (p.operation !== 'insert_after') {
        const key = `${p.id}::${p.sourceFile}`;
        changedParaMap[key] = p;
      }
    });

    const insertAfterMap = {};
    allParagraphs?.forEach(p => {
      if (p.operation === 'insert_after') {
        const key = `${p.id}::${p.sourceFile}`;
        if (!insertAfterMap[key]) insertAfterMap[key] = [];
        insertAfterMap[key].push(p);
      }
    });

    const insertAfterConsumed = {};

    const payloadSections = [];
    sections?.forEach(section => {
      const sectionParas = [];

      (section.paragraphs || [])?.forEach(para => {
        const key = `${para.id}::${para.sourceFile}`;

        if (changedParaMap[key]) {
          const changed = changedParaMap[key];
          sectionParas?.push({
            id: changed.id,
            style: changed.style,
            sourceFile: changed.sourceFile,
            content: changed.content,
            html: changed.html,
            operation: changed.operation,
            condition: para.condition ?? null,
          });
        }

        if (insertAfterMap[key]) {
          const consumed = insertAfterConsumed[key] || 0;
          const inserts = insertAfterMap[key];
          for (let i = consumed; i < inserts?.length; i++) {
            const p = inserts[i];
            sectionParas?.push({
              id: p.id,
              style: p.style,
              sourceFile: p.sourceFile,
              content: p.content,
              html: p.html,
              operation: p.operation,
              condition: null,
            });
          }
          insertAfterConsumed[key] = inserts?.length;
        }
      });

      if (sectionParas?.length > 0) {
        payloadSections?.push({
          heading: section.heading || '',
          htmlHeading: section.htmlHeading || '',
          article: section.article || '',
          sourceFile: section.sourceFile || '',
          paragraphs: sectionParas,
        });
      }
    });

    const payload = {
      docTypeId: docTypeIds?.map(Number),
      stateId: stateIds?.map(Number),
      variant: 1,
      isIntake: isIntake ?? 0,
      userId: commonLib.getSessionStoarge('loggedUserId') || null,
      subtenantId: previewData?.subtenantId ?? null,
      versioningId: previewData?.versioningId ?? null,
      sections: payloadSections,
    };

    onSave(payload);
  }, [previewData, stateIds, docTypeIds, onSave, isIntake]);

  const normalizeHtml = (html) => {
    if (!html) return '';

    let result = html
      .replace(/<strike(\s|>)/gi, '<s$1')
      .replace(/<\/strike>/gi, '</s>');

    const temp = document.createElement('div');
    temp.innerHTML = result;

    temp.querySelectorAll('[data-color-span]')?.forEach(el => {
      el.style.removeProperty('font-family');
      el.style.removeProperty('font-size');
      el.removeAttribute('data-color-span');
      if (!el.style.cssText.trim()) el.removeAttribute('style');
    });

    temp.querySelectorAll('.para-locked-text')?.forEach(el => {
      const parent = el.parentNode;
      while (el?.firstChild) parent.insertBefore(el?.firstChild, el);
      parent.removeChild(el);
    });

    temp.querySelectorAll('.doc-br-wrap')?.forEach(el => {
      const parent = el.parentNode;
      const br = document.createElement('br');
      parent.insertBefore(br, el);
      parent.removeChild(el);
    });

    temp.querySelectorAll('.doc-line')?.forEach((el, idx, list) => {
      const parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      if (idx < list.length - 1) {
        parent.insertBefore(document.createElement('br'), el);
      }
      parent.removeChild(el);
    });

    temp.querySelectorAll('.will-placeholder')?.forEach(el => {
      const text = el.textContent || '';
      if (/^\{[^{}]+\}$/.test(text.trim())) {
        const parent = el.parentNode;
        parent.insertBefore(document.createTextNode(text), el);
        parent.removeChild(el);
      }
    });

    temp.querySelectorAll('font')?.forEach(el => {
      const span = document.createElement('span');
      if (el.style.cssText) {
        span.style.cssText = el.style.cssText;
        span.style.removeProperty('font-family');
        if (!span.style.cssText.trim()) span.removeAttribute('style');
      }
      while (el.firstChild) span.appendChild(el.firstChild);
      el.parentNode?.replaceChild(span, el);
    });

    temp.querySelectorAll('[style]')?.forEach(el => {
      el.style.removeProperty('font-family');
      const sorted = el.style.cssText
        ?.split(';')
        ?.map(s => s.trim())
        ?.filter(Boolean)
        ?.sort()
        ?.join('; ');
      if (sorted) {
        el.setAttribute('style', sorted);
      } else {
        el.removeAttribute('style');
      }
    });

    temp.querySelectorAll('span:not([class]):not([style])')?.forEach(el => {
      const parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });

    return temp.innerHTML;
  };

  const stripInlineFontSize = (html) => {
    if (!html) return html;
    return html.replace(/font-size\s*:\s*[^;"']+;?/gi, '');
  };

  const getInnerFromHtml = (htmlString) => {
    if (!htmlString) return '';
    const temp = document.createElement('div');
    temp.innerHTML = htmlString;
    const firstChild = temp.firstElementChild;
    if (firstChild && (firstChild.tagName === 'P' || firstChild.tagName === 'DIV')) {
      return firstChild.innerHTML;
    }
    return htmlString;
  };

  const wrapWithTag = (para, innerHtml, blockEl) => {
    let inlineStyle = '';
    let restartAttrs = '';
    if (blockEl) {
      if (blockEl.style && blockEl.style.cssText) {
        const currentStyle = blockEl.style.cssText;
        const compositeKey = `${para.id}::${para.sourceFile}`;
        const originalStyle = originalStyleMap.current[compositeKey] || '';
        if (currentStyle !== originalStyle) inlineStyle = ` style="${currentStyle}"`;
      }
      const restartValue = blockEl.getAttribute('data-restart-value');
      const restartArticle = blockEl.getAttribute('data-restart-article');
      if (restartValue) restartAttrs += ` data-restart-value="${restartValue}"`;
      if (restartArticle) restartAttrs += ` data-restart-article="${restartArticle}"`;
    }

    const classMatch = para.html?.match(/class=['"]([^'"]+)['"]/);
    const originalClass = classMatch ? classMatch[1] : 'doc-para';

    if (para.style === 'table') return innerHtml;

    return `<p class='${originalClass}'${inlineStyle}${restartAttrs}>${innerHtml}</p>`;
  };

  const shouldShowPara = (para, conditionFilter) => {
    if (!conditionFilter) return true;
    const cond = para?.condition;
    if (!cond) return false;
    return cond.label === conditionFilter;
  };

  const A4_HEIGHT_PX = 1123;
  const CHARS_PER_PAGE = 3000;

  const buildVersionHtml = (xmlString) => {
    if (!xmlString) return '';

    const parser = new XMLParser({
      ignoreAttributes: false,
      attributeNamePrefix: '@_',
      allowBooleanAttributes: true,
      preserveOrder: true,
      cdataPropName: '__cdata',
      textNodeName: '#text',
      trimValues: false,
    });

    let cleanXml = xmlString
      .replace(/<\?xml[\s\S]*?\?>/gi, '')
      .replace(/\r\n/g, '\n')
      .trim();

    let parsed;
    try {
      parsed = parser.parse(cleanXml);
    } catch (err) {
      return buildVersionHtmlFallback(xmlString);
    }

    const PLACEHOLDER_TAGS = new Set([
      'clientName', 'spouseName', 'agentName', 'successorName', 'signDate',
      'notaryName', 'notaryExpiry', 'revocationCurrentDate', 'clientAlias',
      'heShe', 'hisHer', 'clientMailingStreet', 'clientCityStateZip',
      'witness1Name', 'witness2Name', 'clientNameNotary', 'agentRelationship',
      'agentAddress', 'agentZipCity', 'agentPhone', 'successorRelationship',
      'successorAddress', 'successorZipCity', 'successorPhone',
    ]);

    const styleMap = {
      'centered-bold-para': 'doc-centered-bold',
      'centered-bold-para-arial': 'doc-centered-bold',
      'centered-bold-underline-para': 'doc-centered-bold',
      'centered-bold-underline-para-18': 'doc-centered-bold',
      'centered-para': 'doc-centered',
      'centered-para-16': 'doc-centered',
      'para-1': 'doc-para',
      'para-2': 'doc-para',
      'para-2-justify': 'doc-para',
      'para-indent-720-justify': 'doc-para',
      'para-sublist': 'doc-bullet',
      'para-sublist-v7': 'doc-bullet',
      'para-hotdocs': 'doc-para',
      'para-intro': 'doc-para',
      'para-continuation': 'doc-para',
      'para-bold-block': 'doc-para',
      'para-1-v7': 'doc-para',
    };

    const collectParagraphs = (nodes) => {
      const paragraphs = [];
      if (!Array.isArray(nodes)) nodes = [nodes];

      for (const node of nodes) {
        if (!node || typeof node !== 'object') continue;

        if (node['#text'] !== undefined && Object.keys(node).length === 1) continue;

        if (node.sectionBreak !== undefined) continue;

        if (node.p !== undefined) {
          const attrs = node[':@'] || {};
          paragraphs.push({ children: Array.isArray(node.p) ? node.p : [node.p], attrs });
        } else {
          const keys = Object.keys(node)?.filter(k => k !== ':@' && k !== '#text' && k !== '__cdata');
          for (const key of keys) {
            const child = node[key];
            if (Array.isArray(child)) {
              paragraphs.push(...collectParagraphs(child));
            } else if (typeof child === 'object' && child !== null) {
              paragraphs.push(...collectParagraphs([child]));
            }
          }
        }
      }
      return paragraphs;
    };

    const renderParagraphContent = (children) => {
      if (!children || !Array.isArray(children)) return '';
      let content = '';

      for (const child of children) {
        if (!child || typeof child !== 'object') continue;

        if (child['#text'] !== undefined) {
          const raw = String(child['#text']);
          if (raw.trim() === '') {
            content += ' ';
          } else {
            content += raw;
          }
          continue;
        }

        if (child.t !== undefined) {
          const attrs = child[':@'] || {};
          const tStyle = attrs['@_style'] || '';
          const tChildren = Array.isArray(child.t) ? child.t : [child.t];
          let tText = '';

          for (const tc of tChildren) {
            if (tc && typeof tc === 'object' && tc['#text'] !== undefined) {
              tText += String(tc['#text']);
            } else if (typeof tc === 'string') {
              tText += tc;
            }
          }

          if (!tText && typeof child.t === 'string') {
            tText = child.t;
          }

          if (tStyle.includes('bold')) {
            content += `<strong>${tText}</strong>`;
          } else {
            content += tText;
          }
          continue;
        }

        if (child.pageBreak !== undefined) {
          content += '<div class="doc-page-break" contenteditable="false"><span class="page-break-label">— Page Break —</span></div>';
          continue;
        }

        if (Object.prototype.hasOwnProperty.call(child, 'br')) {
          content += '<br/>';
          continue;
        }

        const childKeys = Object.keys(child)?.filter(k => k !== ':@');
        for (const key of childKeys) {
          if (PLACEHOLDER_TAGS.has(key)) {
            content += `<span class="will-placeholder" contenteditable="false">[${key}]</span>`;
          }
        }
      }

      return content;
    };

    const allParagraphs = collectParagraphs(parsed);

    if (allParagraphs?.length === 0) {
      const plain = cleanXml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      return `<div class="doc-a4-page" data-page="1"><div class="doc-editor-block doc-para">${plain}</div></div>`;
    }

    const A4_HEIGHT = 1123;
    const LINE_HEIGHT = 24.5;
    const CHARS_PER_LINE = 72;
    const pages = [];
    let currentPage = [];
    let currentHeight = 0;

    for (const para of allParagraphs) {
      const attrs = para.attrs || {};
      const styleVal = attrs['@_style'] || 'para-2';
      const alignVal = attrs['@_align'] || '';
      const indentLeft = attrs['@_indentLeft'] || '';

      const cssClass = styleMap[styleVal] || 'doc-para';
      let inlineStyle = '';
      if (alignVal === 'center') inlineStyle += 'text-align:center;';
      else if (alignVal === 'right') inlineStyle += 'text-align:right;';
      else if (alignVal === 'justify') inlineStyle += 'text-align:justify;';
      if (indentLeft) inlineStyle += `padding-left:${Math.round(Number(indentLeft) / 20)}px;`;

      const paraContent = renderParagraphContent(para.children);
      const textLen = paraContent.replace(/<[^>]+>/g, '')?.length;
      const estimatedLines = Math.max(1, Math.ceil(textLen / CHARS_PER_LINE));
      const estimatedHeight = estimatedLines * LINE_HEIGHT + 12;

      if (paraContent.includes('doc-page-break')) {
        if (currentPage?.length > 0) {
          pages.push(currentPage);
          currentPage = [];
          currentHeight = 0;
        }
        continue;
      }

      if (currentHeight + estimatedHeight > A4_HEIGHT - 144 && currentPage?.length > 0) {
        pages.push(currentPage);
        currentPage = [];
        currentHeight = 0;
      }

      currentPage.push({ cssClass, inlineStyle, paraContent });
      currentHeight += estimatedHeight;
    }
    if (currentPage?.length > 0) pages.push(currentPage);

    let html = '';
    pages?.forEach((pageParagraphs, pageIdx) => {
      html += `<div class="doc-a4-page" data-page="${pageIdx + 1}">`;
      for (const { cssClass, inlineStyle, paraContent } of pageParagraphs) {
        const styleAttr = inlineStyle ? ` style="${inlineStyle}"` : '';
        html += `<div class="doc-editor-block ${cssClass}"${styleAttr}>${paraContent || '&nbsp;'}</div>`;
      }
      html += `<span class="doc-a4-page-num">Page ${pageIdx + 1}</span>`;
      html += '</div>';
      if (pageIdx < pages?.length - 1) {
        html += `<div class="doc-page-separator" contenteditable="false"><span class="doc-page-separator-label">Page ${pageIdx + 2}</span></div>`;
      }
    });

    return html;
  };

  const buildVersionHtmlFallback = (xmlString) => {
    if (!xmlString) return '';

    let xml = xmlString
      .replace(/<\?xml[\s\S]*?\?>/gi, '')
      .replace(/<\/?cw:[^>]*>/gi, '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .replace(/<sectionBreak[\s\S]*?<\/sectionBreak>/gi, '');

    const pRegex = /<p\b([^>]*)>([\s\S]*?)<\/p>/gi;
    const placeholderRegex = /<(clientName|spouseName|agentName|successorName|signDate|notaryName|notaryExpiry|revocationCurrentDate|clientAlias|heShe|hisHer|clientMailingStreet|clientCityStateZip|witness1Name|witness2Name|clientNameNotary|agentRelationship|agentAddress|agentZipCity|agentPhone|successorRelationship|successorAddress|successorZipCity|successorPhone)[^>]*\/>/gi;

    const styleMap = {
      'centered-bold-para': 'doc-centered-bold',
      'centered-para': 'doc-centered',
      'para-1': 'doc-para',
      'para-2': 'doc-para',
    };

    let html = '<div class="doc-a4-page" data-page="1">';
    let pMatch;

    while ((pMatch = pRegex.exec(xml)) !== null) {
      const pAttrs = pMatch[1] || '';
      const pInner = pMatch[2] || '';
      const styleMatch = pAttrs.match(/style=['"]([^'"]+)['"]/i);
      const styleVal = styleMatch ? styleMatch[1] : 'para-2';
      const alignMatch = pAttrs.match(/align=['"]([^'"]+)['"]/i);
      const alignVal = alignMatch ? alignMatch[1] : '';
      const cssClass = styleMap[styleVal] || 'doc-para';
      const alignStyle = alignVal === 'center' ? ' style="text-align:center"' : '';

      let paraText = '';
      let tMatch;
      let lastIndex = 0;
      const tRegexLocal = /<t\b([^>]*)>([\s\S]*?)<\/t>/gi;
      while ((tMatch = tRegexLocal.exec(pInner)) !== null) {
        const between = pInner.slice(lastIndex, tMatch.index);
        if (paraText && /\s/.test(between)) {
          paraText += ' ';
        }
        const tAttrs = tMatch[1] || '';
        const tText = tMatch[2] || '';
        const tStyleMatch = tAttrs.match(/style=['"]([^'"]+)['"]/i);
        const tStyle = tStyleMatch ? tStyleMatch[1] : '';
        if (tStyle.includes('bold')) {
          paraText += `<strong>${tText}</strong>`;
        } else {
          paraText += tText;
        }
        lastIndex = tRegexLocal.lastIndex;
      }

      paraText = paraText || pInner
        .replace(/<t\b[^>]*>([\s\S]*?)<\/t>/gi, '$1')
        .replace(placeholderRegex, (m, tag) => `<span class="will-placeholder" contenteditable="false">[${tag}]</span>`)
        .replace(/<br\s*\/?>/gi, '<br/>')
        .replace(/<[^>]+>/g, '');

      if (paraText.trim() || paraText.includes('placeholder')) {
        html += `<div class="doc-editor-block ${cssClass}"${alignStyle}>${paraText}</div>`;
      }
    }

    if (html === '<div class="doc-a4-page" data-page="1">') {
      const plain = xml.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      html += `<div class="doc-editor-block doc-para">${plain}</div>`;
    }

    html += '</div>';
    return html;
  };

  const computeCounterLabels = (paras) => {
    const labels = new Map();
    let docNum = 0, docArticle1 = 0, docArticle1Sub = 0;
    let docArticle8 = 0, docArticle8SubSub = 0;
    let docAlpha = 0, docAlphaUpper = 0, docRoman = 0, docRomanUpper = 0;

    paras.forEach(para => {
      if (para.style === 'table') return;

      const cls = getParaClass(para);
      switch (cls) {
        case 'doc-numbered':
          docNum += 1; docAlpha = 0; docAlphaUpper = 0; docRoman = 0; docRomanUpper = 0;
          labels.set(para.id, `${docNum}. `);
          break;
        case 'doc-article1-heading':
          docArticle1 += 1; docArticle1Sub = 0;
          labels.set(para.id, `ARTICLE ${toUpperRoman(docArticle1)}  `);
          break;
        case 'doc-article1-sub': {
          const restartArticle = getParaRestartArticle(para);
          const restartValue = getParaRestart(para);
          if (restartArticle) docArticle1 = restartArticle;
          docArticle1Sub = restartValue ? restartValue : docArticle1Sub + 1;
          labels.set(para.id, `${docArticle1}.${docArticle1Sub}  `);
          break;
        }
        case 'doc-article8-heading':
          docArticle8 += 1; docArticle8SubSub = 0;
          labels.set(para.id, `Article ${toUpperRoman(docArticle8)}  `);
          break;
        case 'doc-article8-subsub':
          docArticle8SubSub += 1;
          labels.set(para.id, `(${toLowerAlpha(docArticle8SubSub)})  `);
          break;
        case 'doc-numbered-alpha':
          docAlpha += 1;
          labels.set(para.id, `${toLowerAlpha(docAlpha)}. `);
          break;
        case 'doc-numbered-alpha-upper':
          docAlphaUpper += 1;
          labels.set(para.id, `${toLowerAlpha(docAlphaUpper).toUpperCase()}. `);
          break;
        case 'doc-numbered-roman':
          docRoman += 1;
          labels.set(para.id, `${toLowerRoman(docRoman)}. `);
          break;
        case 'doc-numbered-roman-upper':
          docRomanUpper += 1;
          labels.set(para.id, `${toUpperRoman(docRomanUpper)}. `);
          break;
        default:
          break;
      }
    });

    return labels;
  }

  const stripCounterClassesInTables = (html) => {
    if (!html) return html;
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const COUNTER_CLASSES = [
      'doc-numbered', 'doc-numbered-alpha', 'doc-numbered-roman',
      'doc-article1-sub', 'doc-article8-subsub',
    ];
    temp.querySelectorAll('td, th').forEach(cell => {
      cell.querySelectorAll(COUNTER_CLASSES.map(c => `.${c}`).join(',')).forEach(el => {
        COUNTER_CLASSES.forEach(c => el.classList.remove(c));
        el.classList.add('doc-para');
      });
    });
    return temp.innerHTML;
  };

const COUNTER_OVERRIDE_STYLE = `<style>
.doc-numbered::before,
.doc-article1-heading::before,
.doc-article1-sub::before,
.doc-article8-heading::before,
.doc-article8-subsub::before,
.doc-numbered-alpha::before,
.doc-numbered-alpha-upper::before,
.doc-numbered-roman::before,
.doc-numbered-roman-upper::before { content: attr(data-counter-label) !important; font-weight: bold; }

.doc-numbered {
  font-family:Georgia,serif; font-size:14px; line-height:1.8; margin-bottom:6px;
  padding-left:24px; position:relative; text-align:left;
}
.doc-numbered::before { position:absolute; left:0; font-weight:bold; }

.doc-article1-sub {
  font-family:Georgia,serif; font-size:14px; line-height:1.8; margin-bottom:6px;
  padding-left:48px; position:relative; text-align:left;
}
.doc-article1-sub::before { position:absolute; left:24px; font-weight:bold; }

.doc-numbered-alpha,
.doc-numbered-alpha-upper {
  font-family:Georgia,serif; font-size:14px; line-height:1.8; margin-bottom:6px;
  padding-left:72px; position:relative; text-align:left;
}
.doc-numbered-alpha::before,
.doc-numbered-alpha-upper::before { position:absolute; left:48px; font-weight:bold; }

.doc-numbered-roman,
.doc-numbered-roman-upper {
  font-family:Georgia,serif; font-size:14px; line-height:1.8; margin-bottom:6px;
  padding-left:96px; position:relative; text-align:left;
}
.doc-numbered-roman::before,
.doc-numbered-roman-upper::before { position:absolute; left:72px; font-weight:bold; }
</style>`;

  const getDocumentStyles = () => {
    if (previewData?.fullHtml) {
      const match = previewData.fullHtml.match(/<style>([\s\S]*?)<\/style>/i);
      if (match) return match[1];
    }
    if (previewData?.styles) return previewData.styles;
    return null;
  };

  const buildEditableHtml = (conditionFilter) => {
    if (!previewData || !previewData.sections) return '';

    const paras = [];
    previewData.sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => {
        if (conditionFilter && !shouldShowPara(para, conditionFilter)) return;
        paras.push(para);
      });
    });

    const lockMap = buildLockMap(paras);
    const headingLocks = autoLockHeadings(paras);
    const fullLockSet = buildFullLockSet(paras);
    const counterLabels = computeCounterLabels(paras);

    const NUMBERED_CLASSES_FOR_CONTINUATION = ['doc-numbered', 'doc-article1-sub', 'doc-article8-subsub', 'doc-numbered-alpha', 'doc-numbered-roman'];
    const continuationParaIds = new Set();
    for (let i = 1; i < paras.length; i++) {
      const prev = paras[i - 1];
      const curr = paras[i];
      if (curr.style === 'table' || prev.style === 'table') continue;
      const prevClass = getParaClass(prev);
      const currClass = getParaClass(curr);
      if (currClass === 'doc-para' && NUMBERED_CLASSES_FOR_CONTINUATION.includes(prevClass)) {
        continuationParaIds.add(curr.id);
      }
    }

    const pages = [];
    let currentPage = [];
    let currentHeight = 0;

    paras?.forEach(para => {
      const paraHtml = para.html || '';
      const paraText = (para.content || paraHtml.replace(/<[^>]+>/g, '')).trim();

      const isHardPageBreak =
        para.style === 'page-break' ||
        /page-break-after\s*:\s*always/i.test(paraHtml) ||
        /break-after\s*:\s*page/i.test(paraHtml) ||
        /class=["']?[^"']*doc-page-break/i.test(paraHtml) ||
        /^—?\s*page break\s*—?$/i.test(paraText);

      const textLen = (para.html || '').replace(/<[^>]+>/g, '')?.length;
      const lineHeight = 24.5;
      const charsPerLine = 72;
      const estimatedLines = Math.max(1, Math.ceil(textLen / charsPerLine));
      const estimatedHeight = estimatedLines * lineHeight + 12;

      if (isHardPageBreak) {
        if (currentPage?.length > 0) {
          pages.push(currentPage);
          currentPage = [];
          currentHeight = 0;
        }
        return;
      }

      if (currentHeight + estimatedHeight > A4_HEIGHT_PX - 144 && currentPage?.length > 0) {
        pages.push(currentPage);
        currentPage = [];
        currentHeight = 0;
      }
      currentPage.push(para);
      currentHeight += estimatedHeight;
    });
    if (currentPage?.length > 0) pages.push(currentPage);
    let html = '';
    pages?.forEach((pageParagraphs, pageIdx) => {
      html += `<div class="doc-a4-page" data-page="${pageIdx + 1}">`;
      pageParagraphs?.forEach(para => {
        if (para.style === 'table') {
          const cleanedTableHtml = stripCounterClassesInTables(stripInlineFontSize(para.html));
          const tableHtml = makePlaceholdersNonEditable(cleanedTableHtml);
          html += `<div class="doc-editor-block doc-table-block" data-para-id="${para.id}" data-source-file="${para.sourceFile}">${tableHtml}</div>`;
        } else {
          const inner = stripInlineFontSize(getInnerFromHtml(para.html));
          const classMatch = para.html?.match(/class=['"]([^'"]+)['"]/);
          let originalClass = classMatch ? classMatch[1] : 'doc-para';
          if (continuationParaIds.has(para.id)) {
            originalClass = 'doc-continuation';
          }
          let safeInner = makePlaceholdersNonEditable(inner || '&nbsp;');
          const isLockedHeading = headingLocks.has(para.id);
          const isFullyLocked = fullLockSet.has(para.id);

          if (!isLockedHeading && !isFullyLocked) {
            const lockInstruction = lockMap.get(para.id);
            if (lockInstruction) {
              safeInner = applyPartialLock(safeInner, lockInstruction.rule, lockInstruction.lockStart, lockInstruction.lockEnd);
            }
          }

          const blockClass = `doc-editor-block ${originalClass}${(isLockedHeading || isFullyLocked) ? ' doc-heading-locked' : ''}`;
          const blockAttrs = (isLockedHeading || isFullyLocked) ? ' contenteditable="false"' : '';
          const counterLabel = counterLabels.get(para.id);
          const labelAttr = counterLabel ? ` data-counter-label="${counterLabel.replace(/"/g, '&quot;')}"` : '';

          const restartValue = getParaRestart(para);
          const restartArticle = getParaRestartArticle(para);
          let restartAttr = '';
          if (restartValue) restartAttr += ` data-restart-value="${restartValue}"`;
          if (restartArticle) restartAttr += ` data-restart-article="${restartArticle}"`;

          html += `<div class="${blockClass}" data-para-id="${para.id}" data-source-file="${para.sourceFile}"${blockAttrs}${labelAttr}${restartAttr}>${safeInner}</div>`;
        }
      });
      html += `<span class="doc-a4-page-num">Page ${pageIdx + 1}</span>`;
      html += `</div>`;
      if (pageIdx < pages?.length - 1) {
        html += `<div class="doc-page-separator" contenteditable="false">
        <span class="doc-page-separator-label">Page ${pageIdx + 2}</span>
      </div>`;
      }
    });

    return COUNTER_OVERRIDE_STYLE + html;
  };

  const stampParaIds = (editorEl, sections) => {
    const allBlocks = Array.from(editorEl.children)?.filter(el =>
      !el.classList?.contains('doc-page-break') && el.tagName !== 'STYLE'
    );

    const allParas = [];
    sections?.forEach(section => {
      (section.paragraphs || [])?.forEach(para => allParas.push(para));
    });

    let paraIdx = 0;
    allBlocks?.forEach(block => {
      if (paraIdx >= allParas?.length) return;
      const para = allParas[paraIdx];
      block.setAttribute('data-para-id', para.id);
      block.setAttribute('data-source-file', para.sourceFile);
      paraIdx++;
    });
  };

  const makePlaceholdersNonEditable = (html) => {
    if (!html) return html;

    let result = html;
    if (/<br\s*\/?>/i.test(result)) {
      const parts = result.split(/<br\s*\/?>/i);
      if (parts.length > 1) {
        result = parts.map(part => `<div class="doc-line">${part || '&nbsp;'}</div>`).join('');
      }
    }

    result = result.replace(
      /<span\s+class=['"]will-placeholder['"]/g,
      '<span contenteditable="false" class="will-placeholder"'
    );

    result = result
      .split(/(<[^>]*>)/)
      .map((part, i) => {
        if (i % 2 === 1) return part;
        return part.replace(
          /(\{[^{}]+\})/g,
          (match) => `<span contenteditable="false" class="will-placeholder" style="white-space:nowrap;">${match}</span>`
        );
      })
      .join('');

    return result;
  };

  const applyPartialLock = (innerHtml, rule, lockStart, lockEnd) => {
    if (!innerHtml || !rule) return innerHtml;

    const root = document.createElement('div');
    root.innerHTML = innerHtml;

    const collectTextNodes = (el) => {
      const nodes = [];
      const walk = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          nodes.push(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          node.childNodes?.forEach(walk);
        }
      };
      walk(el);
      return nodes;
    };

    const buildTextMap = (el) => {
      const nodes = collectTextNodes(el);
      let offset = 0;
      return nodes?.map(n => {
        const entry = { node: n, start: offset, end: offset + n.textContent.length };
        offset += n.textContent?.length;
        return entry;
      });
    };

    const wrapTextRange = (el, charStart, charEnd) => {
      const textMap = buildTextMap(el);
      const plainText = textMap?.map(e => e.node.textContent).join('');
      if (charStart < 0 || charEnd > plainText?.length || charStart >= charEnd) return;

      const affectedNodes = [];
      for (const entry of textMap) {
        if (entry.end <= charStart || entry.start >= charEnd) continue;
        const sliceStart = Math.max(0, charStart - entry.start);
        const sliceEnd = Math.min(entry.node.textContent?.length, charEnd - entry.start);
        affectedNodes.push({ node: entry.node, sliceStart, sliceEnd, globalStart: entry.start });
      }
      if (!affectedNodes?.length) return;

      const nodesToWrap = [];
      for (const { node, sliceStart, sliceEnd } of affectedNodes) {
        const text = node.textContent;
        const isFullNode = sliceStart === 0 && sliceEnd === text?.length;

        if (!isFullNode) {
          const before = sliceStart > 0 ? document.createTextNode(text.slice(0, sliceStart)) : null;
          const target = document.createTextNode(text.slice(sliceStart, sliceEnd));
          const after = sliceEnd < text?.length ? document.createTextNode(text.slice(sliceEnd)) : null;
          const parent = node.parentNode;
          if (before) parent.insertBefore(before, node);
          parent.insertBefore(target, node);
          if (after) parent.insertBefore(after, node);
          parent.removeChild(node);
          nodesToWrap.push(target);
        } else {
          nodesToWrap.push(node);
        }
      }

      const alreadyWrapped = new Set();
      for (const textNode of nodesToWrap) {
        let candidate = textNode;
        while (candidate.parentNode && candidate.parentNode !== el) {
          candidate = candidate.parentNode;
        }
        if (alreadyWrapped.has(candidate)) continue;

        const collectLen = (node) => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent.length;
          let len = 0;
          node.childNodes?.forEach(c => { len += collectLen(c); });
          return len;
        };

        let candidateOffset = 0;
        let found = false;
        const computeOffset = (node) => {
          if (found) return;
          if (node === candidate) { found = true; return; }
          if (node.nodeType === Node.TEXT_NODE) {
            candidateOffset += node.textContent?.length;
          } else {
            node.childNodes?.forEach(computeOffset);
          }
        };
        el.childNodes?.forEach(computeOffset);
        const candidateLen = collectLen(candidate);
        const candidateEnd = candidateOffset + candidateLen;

        const candidateFullyContained = candidateOffset >= charStart && candidateEnd <= charEnd;
        const nodeToWrap = candidateFullyContained ? candidate : textNode;
        alreadyWrapped.add(nodeToWrap);

        const lockedSpan = document.createElement('span');
        lockedSpan.className = 'para-locked-text';
        lockedSpan.setAttribute('contenteditable', 'false');
        const parent = nodeToWrap.parentNode;
        parent.insertBefore(lockedSpan, nodeToWrap);
        lockedSpan.appendChild(nodeToWrap);
      }
    };

    const plainText = (root.textContent || '').replace(/\u00A0/g, ' ');

    if (lockStart && rule.startText) {
      const idx = plainText?.indexOf(rule.startText);
      if (idx !== -1) {
        wrapTextRange(root, idx, idx + rule.startText?.length);
      }
    }

    if (lockEnd && rule.endText) {
      const idx = plainText?.lastIndexOf(rule.endText);
      if (idx !== -1) {
        wrapTextRange(root, idx, idx + rule.endText?.length);
      }
    }

    return root.innerHTML;
  };

  const getParaClass = (para) => {
    const classMatch = para.html?.match(/class=['"]([^'"]+)['"]/);
    return classMatch ? classMatch[1] : 'doc-para';
  };

  const HEADING_STYLES = new Set([
    'doc-centered-bold',
    'doc-centered',
    'doc-article1-heading',
    'doc-article8-heading',
  ]);

  const autoLockHeadings = (paras) => {
    const headingLocks = new Map();
    paras.forEach(para => {
      const cls = getParaClass(para);
      if (HEADING_STYLES.has(cls)) {
        headingLocks.set(para.id, true);
      }
    });
    return headingLocks;
  };

  const buildFullLockSet = (paras) => {
    const lockSet = new Set();
    if (!docTypeIds) return lockSet;

    const docTypeIdNums = (docTypeIds || [])?.map(Number);
    const intakeNum = Number(previewData?.isIntake ?? isIntake ?? 0);

    const getPlainText = (html) => {
      const el = document.createElement('div');
      el.innerHTML = html || '';
      return (el.textContent || '').replace(/\u00A0/g, ' ');
    };

    for (const id of docTypeIdNums) {
      const key = `${id}_${intakeNum}`;
      const rules = FULL_LOCK_CONFIG[key] || FULL_LOCK_CONFIG[`${id}_1`] || FULL_LOCK_CONFIG[`${id}_0`];
      if (!rules) continue;

      for (const rule of rules) {
        for (const para of paras) {
          const plain = getPlainText(para.html);
          if (plain.includes(rule.matchText)) {
            lockSet.add(para.id);
          }
        }
      }
    }

    return lockSet;
  };

  const buildLockMap = (paras) => {
    const lockMap = new Map();
    if (!docTypeIds) return lockMap;

    const docTypeIdNums = (docTypeIds || [])?.map(Number);
    const intakeNum = Number(previewData?.isIntake ?? isIntake ?? 0);

    const getPlainText = (html) => {
      const el = document.createElement('div');
      el.innerHTML = html || '';
      return (el.textContent || '').replace(/\u00A0/g, ' ');
    };

    for (const id of docTypeIdNums) {
      const key = `${id}_${intakeNum}`;
      const rules = PARTIAL_LOCK_CONFIG[key] || PARTIAL_LOCK_CONFIG[`${id}_1`] || PARTIAL_LOCK_CONFIG[`${id}_0`];
      if (!rules) continue;

      for (const rule of rules) {
        if (rule.multiPara) {
          let startParaId = null;
          for (const para of paras) {
            const plain = getPlainText(para.html);
            if (startParaId === null && plain.includes(rule.startText)) {
              startParaId = para.id;
              const existing = lockMap.get(para.id) || {};
              lockMap.set(para.id, {
                ...existing,
                rule,
                lockStart: true,
                lockEnd: existing.lockEnd ?? false,
              });
              continue;
            }
            if (startParaId !== null && rule.endText && plain.includes(rule.endText)) {
              const existing = lockMap.get(para.id) || {};
              const existingEndTextLen = existing.rule?.endText?.length || 0;
              const useExistingRule = existing.lockEnd && existingEndTextLen > rule.endText.length;
              lockMap.set(para.id, {
                ...existing,
                rule: useExistingRule ? existing.rule : rule,
                lockStart: existing.lockStart ?? false,
                lockEnd: true,
              });
              startParaId = null;
            }
          }
        } else {
          for (const para of paras) {
            const plain = getPlainText(para.html);
            if (plain.includes(rule.startText) && plain.includes(rule.endText)) {
              lockMap.set(para.id, { rule, lockStart: true, lockEnd: true });
            }
          }
        }
      }
    }

    return lockMap;
  };

  const getClassFromStyle = (style) => {
    if (style === 'centered-bold-para') return 'doc-centered-bold';
    if (style === 'centered-para' || style === 'centered') return 'doc-centered';
    if (style?.includes('bullet')) return 'doc-bullet';
    return 'doc-para';
  };

  return (
    <div className={`doc-editor-container${isMaximized ? ' doc-editor-maximized' : ''}`}>
      {notifContextHolder}
      <div className="doc-editor-toolbar" onMouseDown={handleToolbarMouseDown}>
        <div className="toolbar-group">
          <button className="toolbar-btn" onClick={handleUndo} data-tooltip="Undo">↶</button>
          <button className="toolbar-btn" onClick={handleRedo} data-tooltip="Redo">↷</button>
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group">
          <FontSizeDropdown value={fontSize} onChange={handleFontSize} />
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group">
          <button className="toolbar-btn toolbar-btn-bold" onClick={handleBold} data-tooltip="Bold">B</button>
          <button className="toolbar-btn toolbar-btn-italic" onClick={handleItalic} data-tooltip="Italic">I</button>
          <button className="toolbar-btn toolbar-btn-underline" onClick={handleUnderline} data-tooltip="Underline">U</button>
          <button className="toolbar-btn toolbar-btn-strike" onClick={handleStrikethrough} data-tooltip="Strikethrough">S</button>
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group">
          <ColorPickerDropdown label="Text Color" icon="A" colors={TEXT_COLORS} currentColor={fontColor} onSelect={handleFontColor} />
          <ColorPickerDropdown label="Highlight" icon="H" colors={HIGHLIGHT_COLORS} currentColor={highlightColor} onSelect={handleHighlight} />
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group">
          <button className="toolbar-btn" onClick={handleAlignLeft} data-tooltip="Align Left">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="10" x2="15" y2="10" /><line x1="3" y1="14" x2="18" y2="14" /><line x1="3" y1="18" x2="13" y2="18" />
            </svg>
          </button>
          <button className="toolbar-btn" onClick={handleAlignCenter} data-tooltip="Align Center">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="6" y1="10" x2="18" y2="10" /><line x1="4" y1="14" x2="20" y2="14" /><line x1="7" y1="18" x2="17" y2="18" />
            </svg>
          </button>
          <button className="toolbar-btn" onClick={handleAlignRight} data-tooltip="Align Right">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="9" y1="10" x2="21" y2="10" /><line x1="6" y1="14" x2="21" y2="14" /><line x1="11" y1="18" x2="21" y2="18" />
            </svg>
          </button>
          <button className="toolbar-btn" onClick={handleAlignJustify} data-tooltip="Justify">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="3" y1="14" x2="21" y2="14" /><line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group">
          <button className="toolbar-btn toolbar-pagebreak-btn" onClick={handleInsertPageBreak} data-tooltip="Insert Page Break">
            ⎘ Pg Break
          </button>
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group doc-search-wrapper" ref={searchWrapperRef}>
          <div className="doc-search-input-container">
            <svg className="doc-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              ref={searchInputRef}
              className="doc-search-input"
              type="text"
              placeholder="Search in document…"
              value={searchTerm}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
              onFocus={() => { if (searchResults?.length > 0) setIsSearchOpen(true); }}
            />
            {searchTerm && (
              <span
                className="doc-search-clear"
                onClick={() => { setSearchTerm(''); setSearchResults([]); setIsSearchOpen(false); }}
              >×</span>
            )}
          </div>
          {isSearchOpen && searchResults?.length > 0 && ReactDOM.createPortal(
            <div className="doc-search-results-panel" style={searchPanelStyle}>
              <div className="doc-search-results-header">
                <span className="doc-search-results-count">{searchResults?.length} result{searchResults?.length !== 1 ? 's' : ''} found</span>
              </div>
              <div className="doc-search-results-list">
                {searchResults?.map((result, idx) => (
                  <div
                    key={`${result?.paraId}-${idx}`}
                    className="doc-search-result-item"
                    onClick={() => handleSearchResultClick(result)}
                  >
                    <div className="doc-search-result-snippet">
                      {highlightSearchTerm(result.snippet, result.term)}
                    </div>
                  </div>
                ))}
              </div>
            </div>,
            document.body
          )}
        </div>

        <div className="toolbar-divider" />

        <div className="toolbar-group toolbar-group-right">
          <button
            className="toolbar-btn toolbar-maxmin-btn"
            onClick={() => setIsMaximized(prev => !prev)}
            data-tooltip={isMaximized ? 'Minimize' : 'Maximize'}
          >
            {isMaximized ? '⊡' : '⛶'}
          </button>
          <button className="toolbar-btn toolbar-save-btn" onClick={handleSave} data-tooltip="Save Changes" disabled={!!versionXml} style={versionXml ? { opacity: 0.4, cursor: 'not-allowed' } : {}}>
            Save
          </button>
          <button
            className="toolbar-btn toolbar-reset-btn"
            onClick={onReset}
            data-tooltip="Reset to original"
            style={versionXml ? { opacity: 0.4, cursor: 'not-allowed', marginLeft: 6 } : { marginLeft: 6 }}
            disabled={!!versionXml}
          >
            Reset
          </button>
        </div>
      </div>

      <div className="doc-editor-body">
        <div className="doc-page-sidebar">
          <button
            className="doc-page-nav-btn"
            onClick={() => scrollToPage(Math.max(1, activePage - 1))}
            disabled={activePage <= 1}
            title="Previous page"
          >
            ▲
          </button>

          <div className="doc-page-list">
            {getPageWindow(activePage, pageCount)?.map(item =>
              typeof item === 'string' ? (
                <span key={item} className="doc-page-ellipsis">⋯</span>
              ) : (
                <button
                  key={item}
                  className={`doc-page-btn${activePage === item ? ' active' : ''}`}
                  onClick={() => scrollToPage(item)}
                  title={`Go to page ${item}`}
                >
                  {item}
                </button>
              )
            )}

            <button
              className="doc-page-nav-btn"
              onClick={() => scrollToPage(Math.min(pageCount, activePage + 1))}
              disabled={activePage >= pageCount}
              title="Next page"
            >
              ▼
            </button>

            <form className="doc-page-jump" onSubmit={handlePageJumpSubmit}>
              <input
                type="number"
                min={1}
                max={pageCount}
                value={pageJumpInput}
                onChange={(e) => setPageJumpInput(e.target.value)}
                placeholder={`${activePage}`}
                title="Jump to page"
              />
            </form>
          </div>
        </div>

        <div
          className="doc-editor-page-wrapper"
          ref={pageWrapperRef}
          onScroll={handlePageWrapperScroll}
        >
          <div
            ref={editorRef}
            className="doc-editor-content doc-content"
            contentEditable
            suppressContentEditableWarning
            spellCheck={false}
            onClick={handleEditorClick}
            onKeyDown={handleEditorKeyDown}
            onMouseUp={handleEditorSelect}
            onKeyUp={handleEditorSelect}
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentEditor;